export default "__VITE_ASSET__B$ks3eSX__"